import { render, staticRenderFns } from "./waterWenStatistics-chukou.vue?vue&type=template&id=92c9c4b0&"
import script from "./waterWenStatistics-chukou.vue?vue&type=script&lang=js&"
export * from "./waterWenStatistics-chukou.vue?vue&type=script&lang=js&"
import style0 from "./waterWenStatistics-chukou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports